(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["twp-product-upsell"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.twp-product-upsell__scroll-container').forEach((container) => {
    const scroller = container.querySelector('.twp-product-upsell__scroller');
    const prevBtn = container.querySelector('.twp-product-upsell__arrow--prev');
    const nextBtn = container.querySelector('.twp-product-upsell__arrow--next');
    const cardWidth = 167;

    function updateArrows() {
      prevBtn.hidden = scroller.scrollLeft <= 0;
      nextBtn.hidden = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth - 1;
    }

    prevBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: -cardWidth * 2, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      scroller.scrollBy({ left: cardWidth * 2, behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });
  } catch(e) { console.error(e); }
})();

})();
